import { render, staticRenderFns } from "./TaskComment.vue?vue&type=template&id=fc4e28c0&"
import script from "./TaskComment.vue?vue&type=script&lang=js&"
export * from "./TaskComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc4e28c0')) {
      api.createRecord('fc4e28c0', component.options)
    } else {
      api.reload('fc4e28c0', component.options)
    }
    module.hot.accept("./TaskComment.vue?vue&type=template&id=fc4e28c0&", function () {
      api.rerender('fc4e28c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Task/TaskComment.vue"
export default component.exports